$(function() {
  var VIEW = {
    MOBILE: 0,
    SMALL: 1,
    LARGE: 2,
    X_LARGE: 3
  }

  var body = $('body');
  var navbar = $('.navbar');
  var menu = $('.mobile-menu');
  var instructions = $('#how .instructions .step');

  // Upload instructions
  if (instructions.length) {
    instructions.hover(function(e) {
      var instruction = $(this);
  
      instructions.removeClass('step-active');
      instruction.addClass('step-active');
    });
  }

  var navbarToggle = $('.navbar-toggle');

  menu.close = function() {
    body.removeClass('menu-open');
    navbar.removeClass('menu-open');
    menu.removeClass('open');
    menu.attr('aria-hidden', true);
  };

  menu.open = function() {
    body.addClass('menu-open');
    navbar.addClass('menu-open');
    menu.addClass('open');
    menu.attr('aria-hidden', false);
  };

  navbarToggle.click(function(e) {
    e.preventDefault();

    if (menu.hasClass('open')) {
      menu.close();
    } else {
      menu.open();
    }
  });
  
  var getMediaSize = function() {
    var width = $(window).width();    
    if(navigator.userAgent.match(/iPad/i) || navigator.userAgent.match(/iPhone/i) || navigator.userAgent.match(/Android/i) || navigator.userAgent.match(/BlackBerry/i) || navigator.userAgent.match(/webOS/i) || width <= 767){
      return VIEW.MOBILE
    } else if (width >= 1280) {
      return VIEW.X_LARGE;
    } else if (width >= 992) {
      return VIEW.LARGE;
    } else {
      return VIEW.SMALL;
    }
  }

  // pricing carousel
  var media = getMediaSize();
  var pricingCarousel = $('.pricing-carousel');
  var pricingTable = pricingCarousel.find('.pricing-table');
  
  var startIndex = pricingCarousel.data('start-index') >= 0 ? pricingCarousel.data('start-index') : 1;

  // set container height
  var pricingList = pricingTable.find('.plan');
  var height = pricingList.first().height();
  pricingTable.find('.main').height(height);

  // slider
  var minSlide;
  var maxSlide;
  var planSel = startIndex;

  // swipe
  pricingCarousel.swipe();

  // number plans
  var buildPlans = function() {
    minSlide = media === VIEW.MOBILE ? 0 : 1;
    maxSlide = pricingList.length - (media === VIEW.MOBILE ? 2 : 3);

    var n = 0;
    var displayCols = pricingCarousel.data('cols') > 3 && media > VIEW.LARGE ? pricingCarousel.data('cols') : 3;
    var max = planSel + displayCols;
    pricingList.each(function(){
      n++;
      if(n > max) {$(this).addClass('hiddenRight');}
      else $(this).removeClass('hiddenRight');
      if(n <= planSel) {$(this).addClass('hiddenLeft');}
      else $(this).removeClass('hiddenLeft');
      $(this).attr('data-order', n - planSel);
      $(this).removeData('order');
    });
  }
  buildPlans();

  // updates slide buttons
  var endOfCards = function(x) {
    if(x < minSlide) {
      $('a.smaller').addClass('stop');
    } else {
      $('a.smaller').removeClass('stop');
    }

    if(x >= maxSlide) {
      $('a.larger').addClass('stop');
    } else {
      $('a.larger').removeClass('stop');
    }
  }

  // slide the pricing carousel left
  var slideLeft = function(){
    if (planSel < minSlide) return false;

    planSel--;
    pricingList.each(function(){
      var getOrder = Number($(this).data('order'));
      var newOrder = getOrder + 1;
      if(newOrder > 3) {$(this).addClass('hiddenRight');}
      else $(this).removeClass('hiddenRight');
      if(newOrder < 1) {$(this).addClass('hiddenLeft');}
      else $(this).removeClass('hiddenLeft');
      $(this).attr('data-order', newOrder);
      $(this).removeData('order');
    });
    endOfCards(planSel);

    return false;
  };
  
  // slide the pricing carousel right
  var slideRight = function(){
    if(planSel >= maxSlide) return false;

    planSel++;
    pricingList.each(function(){
      var getOrder = Number($(this).data('order'));
      var newOrder = getOrder - 1;
      if(newOrder > 3) {$(this).addClass('hiddenRight');}
      else $(this).removeClass('hiddenRight');
      if(newOrder < 1) {$(this).addClass('hiddenLeft');}
      else $(this).removeClass('hiddenLeft');
      $(this).attr('data-order', newOrder);
      $(this).removeData('order');
    });
    endOfCards(planSel);

    return false;
  };

  // Rebuild on resize
  $(window).resize(function(){
    var currentMedia = media;
    media = getMediaSize();

    if (currentMedia !== media) {
      buildPlans();
    }
  });

  // move left
  $('a.smaller').click(slideLeft);
  pricingCarousel.on('swiperight', slideLeft);

  // move right
  $('a.larger').click(slideRight);
  pricingCarousel.on('swipeleft', slideRight);

  $('a[data-target]').click(function() {
    var elem = $('#' + $(this).data('target'));
    
    if (elem.length > 0) {
      menu.close();
      
      elem.animateScroll(1000);
      window.location.hash = '#' + $(this).data('target');
      return false;
    }
  });
});